import { render } from "./product-grid-toolbar.vue?vue&type=template&id=cb99af1e&scoped=true"
import script from "./product-grid-toolbar.vue?vue&type=script&lang=js"
export * from "./product-grid-toolbar.vue?vue&type=script&lang=js"

import "./product-grid-toolbar.vue?vue&type=style&index=0&id=cb99af1e&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb99af1e"]])

export default __exports__